module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/natalia-targoni-6c2c84a122be8c4ef6e2a7fc5a7a8685.png";